import Handsontable from "handsontable";
import {formatExportTimestampSlug} from "../../../../../../utils/formatters";

export type UseCsvExportAPI = {
    exportAsCsv: (hot: Handsontable) => void;
}

export function useCsvExport(): UseCsvExportAPI {
    const exportAsCsv = (hot: Handsontable) => {
        const exportPlugin = hot.getPlugin("exportFile");
        exportPlugin.downloadFile(
            "csv",
            {
                filename: `line_items_${formatExportTimestampSlug(new Date())}`,
                exportHiddenRows: true,
            }
        );
    };

    return {
        exportAsCsv: exportAsCsv
    };
}
